import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const fontCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([type=xs-bold-uppercase]){font-family:Open Sans;font-size:.625rem;font-weight:700;letter-spacing:.03em;line-height:.75rem;text-transform:uppercase}";

const WuiFont$1 = /*@__PURE__*/ proxyCustomElement(class WuiFont extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '81ad137829626e9cfb9840d2db3f78cb9a1ee498' }, h("slot", { key: '5506c28c8c5a6c6d8143101486a1026c6887fb3a' })));
    }
    static get style() { return fontCss; }
}, [257, "wui-font", {
        "type": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-font"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-font":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiFont$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiFont = WuiFont$1;
const defineCustomElement = defineCustomElement$1;

export { WuiFont, defineCustomElement };
